/**
 * Calculates the projected value based on a base value, growth rate, and number of years
 * Formula: baseValue * (1 + growthRate)^yearsElapsed (compound growth)
 *
 * @param baseValue - The initial value to project from
 * @param growthRate - The annual growth rate (e.g., 0.02 for 2%)
 * @param baseYear - The year the base value is from
 * @param targetYear - The year to project to
 * @returns The projected value
 */
const projectValue = (
  baseValue: number,
  growthRate: number,
  baseYear: number,
  targetYear: number
): number => {
  const yearsElapsed = targetYear - baseYear
  const result = baseValue * (1 + growthRate) ** yearsElapsed
  return Math.round(result * 100) / 100 // Round to 2 decimal places
}

export default projectValue
